import axios from '../..';

export const fetchAllStatus = () => axios.get('/api/admin/all-task-status');

export const fetchAllLogs = orgTasId =>
  axios.get(`/api/admin/task-logs/${orgTasId}`);

export const fetchAllUser = () => axios.get('/api/admin/all-admin');
